<template>

        <div class="account-page-padding">
            <template v-if="is_dealer && isConsumerView">
                <p class="paragraph-default" style="margin-bottom: 1rem;">
                    <Link :href="route('account.orders')" id="back_to_dealer_orders">← Back to Dealer Order History</Link>
                </p>
                <D2COrderHistory
                    :orders="props.orders"
                    title="Consumer Order History"
                    :view="props.view"
                    id="user_order_history"
                />
            </template>
            <B2BOrderHistory
                v-else-if="is_dealer"
                :orders="props.orders"
                :has-d2c-orders="!!props.d2cOrders"
                id="dealer_order_history"
            />
            <D2COrderHistory v-else :orders="props.orders" id="user_order_history"/>
        </div>
</template>
<script lang="ts" setup>
    import Account from "@/Shared/Account.vue";
    import B2BOrderHistory from "@/components/B2BOrderHistory.vue";
    import D2COrderHistory from "@/components/D2COrderHistory.vue";
    import type { PropType } from "vue";
    import { type OrderResource } from "@interfaces/Order";
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";
    import { computed, inject } from "vue";
    import { Link } from "@inertiajs/vue3";

    let props = defineProps({
        orders: {
            type: Object as PropType<OrderResource>,
            default: () => ({
                data: [],
                meta: {
                    current_page: 1,
                    last_page: 1,
                    per_page: 1,
                    total: 0
                }
            })
        },
        d2cOrders: {
            type: [Boolean, Object] as PropType<boolean | OrderResource | null>,
            default: null
        },
        view: {
            type: String as PropType<string | null>,
            default: null
        }
    });

    let route = inject("route");
    let store = useSettingsStore();
    let { is_dealer } = storeToRefs(store);

    let isConsumerView = computed(() => props.view === 'consumer');
</script>
